import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { tokenStorage } from '../utils/tokenStorage';
import { logout } from '../store/slices/authSlice';
import { useNotifications } from './useNotifications';

/**
 * Hook for automatic token refresh
 */
export function useTokenRefresh() {
  const dispatch = useDispatch();
  const { notify } = useNotifications();

  const refreshToken = useCallback(async () => {
    // Token refresh requires the user to re-login.
    dispatch(logout());
    tokenStorage.clearTokenData();

    notify.error(
      'Session expired',
      'Please log in again to continue.',
      { autoClose: false }
    );

    return false;
  }, []); // Remove all dependencies to prevent loops

  // Removed complex event handlers that were causing infinite loops

  useEffect(() => {
    // Simple periodic check (every 5 minutes)
    const interval = setInterval(() => {
      if (tokenStorage.isTokenValid() && tokenStorage.needsRefresh()) {
        refreshToken();
      }
    }, 300000); // Check every 5 minutes

    return () => {
      clearInterval(interval);
    };
  }, [refreshToken]);

  return {
    refreshToken,
    isTokenValid: tokenStorage.isTokenValid(),
    needsRefresh: tokenStorage.needsRefresh(),
  };
}